"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffscreenPath = void 0;
var OffscreenPath;
(function (OffscreenPath) {
    OffscreenPath["SERVER_COMMUNICATION"] = "server-communication.html";
})(OffscreenPath = exports.OffscreenPath || (exports.OffscreenPath = {}));
